import { Spinner } from '@/components/Spinner';
import { useParams } from '@tanstack/react-router';
import { useHostDetails } from './host-management/hooks/useGetHostDetails';
import { ManageHost } from './ManageHostManagement';

type SkillValues = {
  appearance: number;
  conversationStyle: number;
  alcoholTolerance: number;
  atmosphere: number;
};

const mapSkillValues = (skills?: Partial<SkillValues>): SkillValues => ({
  appearance: skills?.appearance || 3,
  conversationStyle: skills?.conversationStyle || 3,
  alcoholTolerance: skills?.alcoholTolerance || 3,
  atmosphere: skills?.atmosphere || 3,
});

export const ManageHostManagementContainer = () => {
  const { hostDetails, isFetching } = useHostDetails();
  const params = useParams({
    from: '/(app)/store-information/basic-stores/host-management/$clubid/$manage-host',
  });
  const hostCodeParam = params['manage-host'];

  const defaultValues = {
    id: hostDetails?.id || '',
    clubId: hostDetails?.clubId || '',
    hostId: hostDetails?.hostId || hostDetails?.id || '',
    hostName: hostDetails?.hostName || '',
    position: hostDetails?.position || '',
    createdDate: hostDetails?.createdDate || '',
    updatedDate: hostDetails?.updatedDate || '',
    hostCode: hostDetails?.hostCode || '',
    dobDay: hostDetails?.dobDay || '',
    status: hostDetails?.status || '',
    dobMonth: hostDetails?.dobMonth || '',
    dobYear: hostDetails?.dobYear || '',
    furigana: hostDetails?.furigana || '',
    constellation: hostDetails?.constellation || '',
    mbti: hostDetails?.mbti || '',
    title: hostDetails?.title || '',
    rank: hostDetails?.rank || '',
    birthPlace: hostDetails?.birthPlace || '',
    bloodType: hostDetails?.bloodType || '',
    zodiacSign: hostDetails?.zodiacSign || '',
    formerJob: hostDetails?.formerJob || '',
    alcohol: hostDetails?.alcohol || '',
    height: hostDetails?.height || '',
    instagram: hostDetails?.instagram || '',
    tiktok: hostDetails?.tiktok || '',
    line: hostDetails?.line || '',
    twitter: hostDetails?.twitter || '',
    profileImage: hostDetails?.profileImage?.path || '',
    skills: mapSkillValues(hostDetails?.skills),
  };

  if (isFetching) return <Spinner />;
  return <ManageHost defaultValues={defaultValues} hostCodeParam={hostCodeParam} />;
};
